import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";

export const SignOutPage = () => {
  const auth = useAuthContext();
  const history = useHistory();

  useEffect(() => {
    auth.signOut();
    history.replace(anonymousRouting.buildUrl("signIn"));
  }, [auth, history]);

  return <></>;
};
